import { AdornisRouter } from '@adornis/base/client/a-router';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element';
import { css } from '@adornis/chemistry/directives/css';
import '@adornis/germanium/components/ge-button';
import '@adornis/germanium/fonts';
import { config } from 'config.js';
import { NodeBBTopic } from 'db/nodebb-topics';
import { html, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

@customElement('wtg-forum-topic-preview')
export class WTGForumTopicPreview extends ChemistryLitElement {
  styles = () => ({
    ':host': {
      flex: '1',
      backgroundColor: this.colors.white,
      minWidth: '30%',
      boxShadow: '-1px 10px 15px -11px #262626',
    },
    p: { margin: '0' },
  });

  @state() topic: NodeBBTopic | undefined = undefined;

  public render() {
    if (!this.topic) return nothing;

    return html`
      <x-flex
        padding="lg"
        space="sm"
        @click=${() => AdornisRouter.goToExternal(`https://${config.get('NODEBB_DOMAIN')}/topic/${this.topic!.tid}`)}
      >
        <x-flex horizontal crossaxis-center space="md">
          ${this.topic.user.picture
            ? html`
                <a-image
                  .value=${'https://' + config.get('NODEBB_DOMAIN') + this.topic.user.picture}
                  ${css({ width: '46px', height: '46px', borderRadius: '50%' })}
                  mode="fit"
                ></a-image>
              `
            : html`
                <x-flex
                  center
                  crossaxis-center
                  ${css({
                    width: '46px',
                    height: '46px',
                    backgroundColor: this.colors.secondary,
                    color: 'white',
                    borderRadius: '50%',
                  })}
                >
                  <ge-h3> ${this.topic.user.username.slice(0, 1).toLocaleUpperCase()} </ge-h3>
                </x-flex>
              `}
          <ge-h3 welther>${this.topic.title || 'Kein Post verlinkt'}</ge-h3>
        </x-flex>
        <x-flex flex space="md">
          <ge-h4> Replies: </ge-h4>
          <x-flex
            flex
            ${css({
              position: 'relative',
              padding: '2px 0',
              flexBasis: this.topic.teaser.content ? undefined : '0',
              overflow: 'hidden',
              minHeight: '1em',
              maxHeight: this.topic.teaser.content ? '4em' : 'unset',
            })}
          >
            <ge-h4 grey> ${unsafeHTML(this.topic.teaser.content || 'no replies yet, be first!')} </ge-h4>
            ${this.topic.teaser.content
              ? html`
                  <div
                    ${css({
                      position: 'absolute',
                      width: '100%',
                      height: '30%',
                      maxHeight: '2em',
                      background: `linear-gradient(0deg, ${this.colors.light}, transparent)`,
                      bottom: '0',
                    })}
                  ></div>
                `
              : nothing}
          </x-flex>
        </x-flex>
      </x-flex>
    `;
  }
}
